export default __webpack_public_path__ + "static/media/Jacklin.2e1c6b58.png";